import { useListSupportedAppsQuery } from '../../../../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AppRpc.hooks';
export const useUnifiedAccountSupportedApps = () => {
  const {
    data,
    loading,
    error,
    networkStatus
  } = useListSupportedAppsQuery();
  return {
    data: (data === null || data === void 0 ? void 0 : data.supportedApps) || [],
    loading,
    error: error || null,
    networkStatus
  };
};